
import { useState, useEffect } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useIsMobile } from "@/hooks/use-mobile";

const companyLogos = [
  {
    id: 1,
    name: "Aetna",
    logo: "/lovable-uploads/4ec82f54-0a5d-4472-8e26-6870c69a72ce.png",
  },
  {
    id: 2,
    name: "BlueCross BlueShield",
    logo: "/lovable-uploads/d9251158-d471-41cf-a6d6-93ce526ba02b.png",
  },
  {
    id: 3,
    name: "Cigna",
    logo: "/lovable-uploads/a02131de-ec7b-4e2d-98e4-abd9efb34ce5.png",
  },
  {
    id: 4,
    name: "Oscar",
    logo: "/lovable-uploads/cdb1a29a-742e-4507-9a0f-ec5285bfcc0b.png",
  },
  {
    id: 5,
    name: "AmBetter Health",
    logo: "/lovable-uploads/68c31c60-e0cc-4239-9e26-e83b9284fad4.png",
  },
  {
    id: 6,
    name: "Kaiser Permanente",
    logo: "/lovable-uploads/c6fb9883-2d5b-4c75-a7bf-99dfd5e93a4b.png",
  },
  {
    id: 7,
    name: "UnitedHealthcare",
    logo: "/lovable-uploads/aa23bb0f-1c6d-423b-9802-9dce115adf2b.png",
  },
];

const CompanyCarousel = () => {
  const [api, setApi] = useState<any>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const isMobile = useIsMobile();

  // Update current slide when the carousel changes
  useEffect(() => {
    if (!api) return;

    const handleSelect = () => {
      setCurrentSlide(api.selectedScrollSnap());
      setTotalSlides(api.scrollSnapList().length);
    };

    api.on("select", handleSelect);
    api.on("reInit", handleSelect);

    // Initial values
    handleSelect();

    return () => {
      api.off("select", handleSelect);
      api.off("reInit", handleSelect);
    };
  }, [api]);

  // Auto-advance carousel
  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      api.scrollNext();
    }, 4000);

    return () => clearInterval(interval);
  }, [api]);

  return (
    <div className="relative max-w-4xl mx-auto">
      <Carousel
        opts={{
          align: "center",
          loop: true,
          dragFree: true,
          containScroll: "trimSnaps",
        }}
        setApi={setApi}
        className="w-full"
      >
        <CarouselContent className="-ml-0 md:-ml-0">
          {companyLogos.map((company) => (
            <CarouselItem 
              key={company.id} 
              className={`pl-0 md:pl-0.5 ${isMobile ? 'basis-1/3 px-2' : 'basis-1/5 md:basis-1/6'}`}
            >
              <div className={`${isMobile ? 'h-24 p-2' : 'h-32 p-0'} flex items-center justify-center`}>
                <img 
                  src={company.logo} 
                  alt={company.name}
                  className="max-h-24 w-auto object-contain"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        
        <CarouselPrevious className="absolute left-0 bg-white hover:bg-gray-100 border-gray-200 shadow-md text-gray-700" />
        <CarouselNext className="absolute right-0 bg-white hover:bg-gray-100 border-gray-200 shadow-md text-gray-700" />
      </Carousel>

      {/* Pagination dots */}
      <div className="flex justify-center gap-2 mt-4">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === currentSlide ? "bg-gray-700" : "bg-gray-300"
            }`}
            onClick={() => api?.scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CompanyCarousel;
